/**
 * Story 80, S44 — the client lets the ambiguous cases through and shows the SERVER's message.
 *
 * The check the browser can do is deliberately partial: it cannot tell "just became external" from
 * "untouched job older than the story", because that needs the persisted state. Those arrive as a 409
 * whose message names the offending job, and the whole value of that message is lost if the UI replaces
 * it with a generic failure — which is what the fabrication order's dialog used to do.
 *
 * Extracted (same precedent as `planningGroupSaveError.js`) so the fabrication order's `.catch` and the
 * tests exercise ONE implementation instead of a test-side replica.
 *
 * @param {{message?: string}} error Error thrown by `Api_Functions` on a non-2xx response.
 * @param {Function} t_ Translation function.
 * @returns {{title: string, severity: string, message: string}} Payload for `generic/AlertUI.jsx`.
 */
export const alertForSaveError = (error, t_) => ({
  title: t_('Error saving workflow'),
  severity: 'warning',
  message: error?.message ? t_(error.message) : ''
})
